var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49898 2.99625V4.797C9.47401 5.10005 9.69661 5.36716 9.99919 5.39725H14.0009C14.3034 5.36716 14.526 5.10005 14.5011 4.797V2.99625",
    stroke: "#0074B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99951 18.0025H14.0012",
    stroke: "#0074B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0017 21.0038H7.99839C6.89336 21.0038 5.99756 20.1079 5.99756 19.0029V4.99709C5.99756 3.89206 6.89336 2.99625 7.99839 2.99625H16.0017C17.1068 2.99625 18.0026 3.89206 18.0026 4.99709V19.0029C18.0026 20.1079 17.1068 21.0038 16.0017 21.0038Z",
    stroke: "#0074B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.3e6b3d07fc0edb3fad96406c34e26a55.svg";
export { ForwardRef as ReactComponent };